import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Shield, ArrowLeft, Eye, ShieldCheck, Crown } from 'lucide-react';
import { useUserRole } from '@/hooks/useUserRole';

interface RestrictedAccessMessageProps {
  onViewAnyway?: () => void;
}

const RestrictedAccessMessage: React.FC<RestrictedAccessMessageProps> = ({ 
  onViewAnyway 
}) => {
  const navigate = useNavigate();
  const { canAccessAdminPanel } = useUserRole();

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-black to-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-black/30 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
          <div className="flex justify-center mb-6">
            <div className="bg-luxury-pinkBright/20 p-4 rounded-full">
              <Shield className="h-12 w-12 text-luxury-pinkBright" />
            </div>
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-4">
            Acesso Restrito
          </h1>
          
          <p className="text-white/70 mb-2">
            Este perfil não está disponível para o seu tipo de conta.
          </p>
          
          <p className="text-white/50 text-sm mb-8">
            Patrocinadores podem visualizar apenas perfis de Patrocinados, e vice-versa.
          </p>
          
          <div className="space-y-3">
            {/* Admin/Moderator bypass button */}
            {canAccessAdminPanel && onViewAnyway && (
              <Button 
                onClick={onViewAnyway}
                className="w-full bg-amber-600 hover:bg-amber-700 text-white font-medium py-3 rounded-lg transition-colors"
              >
                <Eye className="h-4 w-4 mr-2" />
                Ver Perfil (Admin)
              </Button>
            )}
            
            {/* Option 1: Complete Verification */}
            <Button 
              onClick={() => navigate('/main/verification')} 
              className="w-full bg-gradient-to-r from-[#C4406B] to-[#9F3764] hover:from-[#9F3764] hover:to-[#8B1538] font-medium py-3 rounded-lg transition-colors"
            >
              <ShieldCheck className="h-4 w-4 mr-2" />
              Completar Verificação
            </Button>
            
            {/* Option 2: Go Premium */}
            <Button 
              onClick={() => navigate('/main/subscriptions')} 
              variant="outline"
              className="w-full border-luxury-pinkBright text-luxury-pinkBright hover:bg-luxury-pinkBright/10 font-medium py-3 rounded-lg transition-colors"
            >
              <Crown className="h-4 w-4 mr-2" />
              Assinar Plano Premium
            </Button>
            
            {/* Option 3: Go Back */}
            <Button 
              onClick={() => navigate(-1)} 
              variant="ghost" 
              className="w-full text-white/60 hover:text-white hover:bg-white/10 py-3 rounded-lg transition-colors"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Voltar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestrictedAccessMessage;
